/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import * as React from "react";
import { useParams } from "react-router-dom";
import { Tab, Tabs } from "@nordcloud/gnui";
import { useLexicalTabsWithUrl } from "~/hooks";
import { RouteParams } from "../types";
import { OrgUnitBudgetTab } from "./OrgUnitBudgetTab";
import OrgUnitCostAnalysisSection from "./OrgUnitCostAnalysisSection";
import { OrgUnitKpiTab } from "./OrgUnitKpiTab";

type Props = {
  applicationIds: string[];
  forecast: number;
};

export function OrgUnitCostTabs({ applicationIds, forecast }: Props) {
  const { activeTab, setActiveTab, registerTabs } =
    useLexicalTabsWithUrl("costTab");
  const { unitId, structureId } = useParams<RouteParams>();

  React.useEffect(() => {
    registerTabs(["cost", "kpi", "budget"]);
    // We don't want registerTabs to avoid excessive recursion
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Tabs step={activeTab} handleTab={setActiveTab}>
      <Tab heading="Cost Analysis">
        <OrgUnitCostAnalysisSection
          orgUnitId={unitId}
          applicationIds={applicationIds}
          forecast={forecast}
        />
      </Tab>
      <Tab heading="KPI Details">
        <OrgUnitKpiTab orgUnitId={unitId} businessContextId={structureId} />
      </Tab>
      <Tab heading="Budget">
        <OrgUnitBudgetTab orgUnitId={unitId} />
      </Tab>
    </Tabs>
  );
}
